import { actionStatus } from '~/features/deviceReports/constants/actionStatus';

export const actionStatusSettings = {
    [actionStatus.SUCCESS]: {
        badge: 'text-color-success uikit-icon icon-ok-sign ',
        label: 'intl-msg:report.successful'
    },
    [actionStatus.FAILURE]: {
        badge: 'text-color-danger uikit-icon icon-remove-sign',
        label: 'intl-msg:report.failed',
    },
    [actionStatus.ONGOING]: {
        badge: 'text-color-warning uikit-icon icon-question-sign',
        label: 'intl-msg:report.notFinished',
    },
    [actionStatus.REBOOT_PENDING]: {
        label: 'intl-msg:report.state.isRebootPending.label',
        message: 'intl-msg:report.state.isRebootPending.message',
        badge: 'text-color-warning uikit-icon icon-time',
    },
};
